import { Component } from '@angular/core'
import { TranslocoModule } from '@jsverse/transloco'

@Component({
   selector: 'app-disclaimer',
   standalone: true,
   imports: [TranslocoModule],
   templateUrl: './disclaimer.component.html'
})
export class DisclaimerComponent {

}
